import { setTenant } from '@/features/configuration/configurationActions';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useDispatch, useSelector } from '@/store/utils';
import type { TenantOption } from '@/types/tenant';
import { cn } from '@/utils/cn';
import { Button, Icons, Popover, Typography } from '@fleet/webshop-ui';

type TenantSelectProps = {
  options: readonly TenantOption[];
};

const TenantSelect = ({ options }: TenantSelectProps) => {
  const selectedTenant = useSelector(tenantSelector);
  const dispatch = useDispatch();

  const handleTenantChange = (tenant: TenantOption) => {
    dispatch(setTenant(tenant));
  };

  return (
    <Popover
      trigger={
        <Button variant="ghostLink" data-testid="tenant-select-trigger">
          <Icons.powerSocket width={24} height={24} />
        </Button>
      }
      content={
        <>
          {options.map((option) => (
            <div
              key={option.value}
              className={cn(
                'flex h-10 w-full items-center justify-between px-3 py-2 text-dark hover:cursor-pointer hover:bg-primary-pale',
                option.value === selectedTenant.value && 'bg-primary-light'
              )}
              onClick={() => handleTenantChange(option)}
              data-testid={`tenant-select-item-${option.value}`}
            >
              <Typography variant="body1">{option.label}</Typography>
              {option.value === selectedTenant.value && (
                <Icons.checkCircle
                  height={16}
                  width={16}
                  className="text-success-text"
                />
              )}
            </div>
          ))}
        </>
      }
      placement="bottom end"
      data-testid="tenant-select-popover"
      className={{ root: 'w-40', content: 'p-0' }}
    />
  );
};

export default TenantSelect;
